import moment from 'moment'
import { DURATION_ZERO } from '../constants'
import { isIso8601Duration } from '../validator/is-iso-8601-duration'

/**
 * Adds a duration to the provided date. If duration is formatted wrong or results as zero duration, the original
 * datetime will be returned as ISO-formatted string. Is the datetime parameter somehow erroneous, the method will
 * return NULL.
 *
 * @param {String} duration - A duration formatted as ISO 8601 string (e.g. "PT4H30M").
 * @param {String|Number|Date|moment.Moment} [datetime=new Date()] - A datetime string, Date or moment object the duration
 *   will be added.
 * @returns {String|null} - The manipulated datetime ISO string or null.
 */
export function addDurationToDate(duration, datetime) {
    const castedDatetime = datetime && moment.isMoment(datetime) ? datetime : datetime && moment(datetime)
    const castedDuration = isIso8601Duration(duration) && moment.duration(duration)
    const isZeroDuration = castedDuration && castedDuration.toISOString() === DURATION_ZERO
    const isValidDatetime = castedDatetime && castedDatetime.isValid()

    if (!isZeroDuration && isValidDatetime) {
        return castedDatetime.add(castedDuration).toISOString()
    }

    if (isZeroDuration && isValidDatetime) {
        return castedDatetime.toISOString()
    }

    return null
}
